/**
 * @graph-stack product-innovation-lab
 * @graph-domain Infrastructure
 * @graph-business i18next初期化。日本語/英語/ベトナム語の翻訳リソースをロードしブラウザ言語検出で自動切替
 * @graph-connects none
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import jaCommon from './locales/ja/common.json';
import jaDbDictionary from './locales/ja/db-dictionary.json';
import jaOps from './locales/ja/ops.json';
import jaSpec from './locales/ja/spec.json';
import jaImprovements from './locales/ja/improvements.json';
import jaProjectDetail from './locales/ja/project-detail.json';
import jaTeamAssignments from './locales/ja/team-assignments.json';
import jaCuttysark from './locales/ja/cuttysark.json';
import jaOrgIssues from './locales/ja/org-issues.json';
import jaTeamMeetings from './locales/ja/team-meetings.json';
import jaBd from './locales/ja/bd.json';
import enCommon from './locales/en/common.json';
import enDbDictionary from './locales/en/db-dictionary.json';
import enOps from './locales/en/ops.json';
import enSpec from './locales/en/spec.json';
import enImprovements from './locales/en/improvements.json';
import enProjectDetail from './locales/en/project-detail.json';
import enTeamAssignments from './locales/en/team-assignments.json';
import enCuttysark from './locales/en/cuttysark.json';
import enOrgIssues from './locales/en/org-issues.json';
import enTeamMeetings from './locales/en/team-meetings.json';
import enBd from './locales/en/bd.json';
import viCommon from './locales/vi/common.json';
import viOps from './locales/vi/ops.json';
import viSpec from './locales/vi/spec.json';
import viImprovements from './locales/vi/improvements.json';
import viProjectDetail from './locales/vi/project-detail.json';
import viTeamAssignments from './locales/vi/team-assignments.json';
import viCuttysark from './locales/vi/cuttysark.json';
import viOrgIssues from './locales/vi/org-issues.json';
import viTeamMeetings from './locales/vi/team-meetings.json';
// 基本設計は既定を英語にするので、vi は英語の文をそのまま持つ（fallbackLng が ja のため、
// 無いと日本語が出る）
import viBd from './locales/vi/bd.json';

/** @graph-connects none */
export const defaultNS = 'common';
/** @graph-connects none */
export const resources = {
  ja: {
    common: {
      ...jaCommon,
      ...jaDbDictionary,
      ...jaOps,
      ...jaSpec,
      ...jaImprovements,
      ...jaProjectDetail,
      ...jaTeamAssignments,
      ...jaCuttysark,
      ...jaOrgIssues,
      ...jaTeamMeetings,
      ...jaBd,
    },
  },
  en: {
    common: {
      ...enCommon,
      ...enDbDictionary,
      ...enOps,
      ...enSpec,
      ...enImprovements,
      ...enProjectDetail,
      ...enTeamAssignments,
      ...enCuttysark,
      ...enOrgIssues,
      ...enTeamMeetings,
      ...enBd,
    },
  },
  vi: {
    common: {
      ...viCommon,
      ...viOps,
      ...viSpec,
      ...viImprovements,
      ...viProjectDetail,
      ...viTeamAssignments,
      ...viCuttysark,
      ...viOrgIssues,
      ...viTeamMeetings,
      ...viBd,
    },
  },
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    defaultNS,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });
